import { IEnvironment } from './environment';

export const environmentProd: IEnvironment = {
    environments: [
        {
            name: 'TestNet',
            url: 'https://api-testnet.ergoplatform.com',
        },
        {
            name: 'Mainnet',
            url: 'https://explorer.ergoplatform.com',
        },
    ],
    isLoggerEnabled: false,
};
